export default __webpack_public_path__ + "static/media/shoe08.c7e91bc7.jpg";